import { useEffect, type FC } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import NewConversationView from "./NewConversationView";
import ConversationDetailView from "./ConversationDetailView";
import ArchiveView from "./ArchiveView";
import UpdatesView from "./UpdatesView";
import { ArchiveButton, NewConversationButton } from "./NavButton";
import { useBlocNext } from "@blac/react";
import AppViewCubit from "src/state/AppViewCubit/AppViewCubit";
import LeapChatCubit from "./LeapChatCubit";

const WithArchiveNav: FC<{ children: React.ReactNode }> = ({ children }) => (
  <>
    <ArchiveButton />
    {children}
  </>
);

const WithNewConvoNav: FC<{ children: React.ReactNode }> = ({ children }) => (
  <>
    <NewConversationButton />
    {children}
  </>
);

const WithBothNav: FC<{ children: React.ReactNode }> = ({ children }) => (
  <>
    <ArchiveButton />
    <NewConversationButton />
    {children}
  </>
);

const LeapChatRouter: FC = () => {
  const [, { setAllowIonContentScrollY }] = useBlocNext(AppViewCubit);
  const [{ activeConversationId }] = useBlocNext(LeapChatCubit);

  useEffect(() => {
    setAllowIonContentScrollY(false);
    return () => {
      setAllowIonContentScrollY(true);
    };
  }, [setAllowIonContentScrollY]);

  return (
    <Routes>
      <Route
        index
        element={
          activeConversationId ? (
            <Navigate
              to={`/app/chat/conversation/${activeConversationId}`}
              replace
            />
          ) : (
            <WithArchiveNav>
              <NewConversationView />
            </WithArchiveNav>
          )
        }
      />
      <Route
        path="new"
        element={
          activeConversationId ? (
            <Navigate
              to={`/app/chat/conversation/${activeConversationId}`}
              replace
            />
          ) : (
            <WithArchiveNav>
              <NewConversationView />
            </WithArchiveNav>
          )
        }
      />
      <Route
        path="updates"
        element={
          <WithBothNav>
            <UpdatesView />
          </WithBothNav>
        }
      />
      <Route
        path="archive"
        element={
          <WithNewConvoNav>
            <ArchiveView />
          </WithNewConvoNav>
        }
      />
      <Route
        path="conversation/:id"
        element={
          <WithArchiveNav>
            <ConversationDetailView />
          </WithArchiveNav>
        }
      />
      <Route path="*" element={<Navigate to="/app/chat" replace />} />
    </Routes>
  );
};

export default LeapChatRouter;
